theme.collectionInfiniteScroll = (function() {
  function InfiniteScroll(container) {
    this.container = container;
    this.productGrid = container.querySelector('#ProductGrid');
    this.paginationType = container.dataset.paginationType;
    
    if (this.paginationType !== 'infinite') return;
    
    this.loading = false;
    this.currentPage = 1;
    
    this._bindEvents();
  }

  InfiniteScroll.prototype = {
    _bindEvents: function() {
      window.addEventListener('scroll', this._throttle(this._onScroll.bind(this), 100));
    },

    _onScroll: function() {
      if (this.loading) return;
      
      var scrolled = window.pageYOffset + window.innerHeight;
      var threshold = this.productGrid.offsetHeight - 1000;

      if (scrolled >= threshold) {
        this._loadNextPage();
      }
    },

    _loadNextPage: function() {
      var nextPageLink = document.querySelector('.pagination .next a');
      if (!nextPageLink) return;

      this.loading = true;
      var loader = this.container.querySelector('.infinite-scroll-loader');
      if (loader) loader.classList.remove('hide');

      fetch(nextPageLink.href)
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newProducts = doc.querySelector('#ProductGrid').innerHTML;
          var newPagination = doc.querySelector('.pagination-wrapper');

          // Append new products
          this.productGrid.insertAdjacentHTML('beforeend', newProducts);

          // Update pagination if it exists
          if (newPagination) {
            this.container.querySelector('.pagination-wrapper').innerHTML = newPagination.innerHTML;
          }

          this.currentPage++;
          this.loading = false;
          if (loader) loader.classList.add('hide');

          // Reinitialize any product-specific features
          if (theme.settings && theme.settings.quickShop) {
            theme.QuickShop.init();
          }
        }.bind(this))
        .catch(function(error) {
          console.error('Error loading more products:', error);
          this.loading = false;
          if (loader) loader.classList.add('hide');
        }.bind(this));
    },

    _throttle: function(func, wait) {
      var timeout = null;
      var previous = 0;

      return function() {
        var now = Date.now();
        var remaining = wait - (now - previous);

        if (remaining <= 0 || remaining > wait) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          previous = now;
          func.apply(this, arguments);
        } else if (!timeout) {
          timeout = setTimeout(function() {
            previous = Date.now();
            timeout = null;
            func.apply(this, arguments);
          }, remaining);
        }
      };
    }
  };

  return InfiniteScroll;
})();

// Initialize infinite scroll
document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('[data-section-type="collection-template"]');
  if (container) {
    new theme.collectionInfiniteScroll(container);
  }
});